var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"popup-scrolltop-container",style:(("bottom: " + (_vm.stylePosition.bottom) + "; right: " + (_vm.stylePosition.right))),on:{"click":_vm.scrollTop}},[_c('i',{staticClass:"fa-solid fa-circle-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }